import { ComponentProps } from 'lib/component-props';
import ArticleHeroImageRight from 'components/Sections/Banners/ArticleHero/ArticleHeroImageRight/ArticleHeroImageRight';
import ArticleHeroImageBackground from 'components/Sections/Banners/ArticleHero/ArticleHeroImageBackground';
import { usePageData } from 'lib/page-data/PageDataContext';

const TrustArticleHero = ({ rendering, params }: ComponentProps): JSX.Element => {
  const { articleData } = usePageData('article') ?? {};

  if (params.imagePosition === 'background') {
    return (
      <ArticleHeroImageBackground data-e2e-component-uid={rendering.uid} article={articleData} />
    );
  }

  return <ArticleHeroImageRight data-e2e-component-uid={rendering.uid} article={articleData} />;
};

export default TrustArticleHero;
